<template>
  <div class="detailBox m-auto w1200 pt-70 pb-30">
    <div class="p25 bg-white">
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadCrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{path:'/news/newsList'}">内容资讯</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="flex justify-between bg-white flexBox">
      <div class="post-detail mt-15">
        <div class="post-head">
          <h1 class="post-title">{{ postDetail.title }}</h1>
          <div class="author-views-time flex justify-between">
            <div class="author-views flex .justify-between text-gray-501">
              <div>
                <span>作者:</span>
                <span class="pl-10">{{ postDetail.author_info ? postDetail.author_info.name : '无' }}</span>
              </div>
              <div class="post-views">
                <span class="iconfont icon-views">{{ postDetail.views }}</span>
              </div>
            </div>
            <div class="time">
              <span class="iconfont icon-nz">{{ postDetail.create_time }}</span>
            </div>
          </div>
        </div>
        <div class="post-content mt-30" v-html="postDetail.content"></div>
      </div>
      <div class="hot-list">
        <div class="ss-news-r">
          <div class="bg-white pl-26 pr-30 mt-15 ml-15 overflow-hidden cur-point">
            <div class="my-30 fs-19 text-gray-900 font-bold f-size-20">热门文章</div>
            <div
                v-for="(item, index) in hotList"
                class="my-20"
                :key="index"
                @click="getPostDetail(item.id)"
            >
              <div class="fs-16 text-gray-900 flex items-center  f-size-16">
                <img :src="arrImg" class="arr-img"/>
                <span class="no-wrap c-666">{{ item.title }}</span>
              </div>
              <div class="text-gray-501 fs-12 mt-15 ml-20 flex justify-between">
                <span>{{ item.createtime }}</span>
                <span class="iconfont icon-views">{{ item.views }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  data() {
    return {
      id: '',//路由传递的id
      hotList: [],//热门推荐的列表
      postDetail: {},//文章详情的列表
      arrImg: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAKCAYAAACJxx+AAAAAiklEQVQYlXXOMQ4BYRCG4WfFCVSUTrANTiEcQKnS7SEoVY7AAbiCSiMaEmcQEbWQyBSb/FnrS6aZ950vkw1n7yUWeKhJA11cMP4nHNDGFhu06oQyE5wxSoUjPonUwQ7raGsiJsRqou0WsI+sQk8osI/LQQLumKIXMBZlwwsrzPFMq0KIRY7rzxf4AupAGBCnWwSNAAAAAElFTkSuQmCC'
    }
  }, methods: {
    async getAllDeatil() {
      const res_2 = await this.$http.get('index.php/user/internal/articles_info', {id: this.id}) // 获取文章详情
      const res_3 = await this.$http.get('index.php/user/internal/views_list') // 热门推荐接口
      res_2.data.create_time = dayjs(res_2.data.create_time).format('YYYY-MM-DD')
      this.postDetail = res_2.data
      this.hotList = res_3.data
      console.log(res_3, '热门推荐的接口')
    },
    async getPostDetail(id) {
      const res = await this.$http.get('index.php/user/internal/articles_info', {id: id})
      res.data.create_time = dayjs(res.data.create_time).format('YYYY-MM-DD')
      console.log(res, 'resresres')
      this.postDetail = res.data
    }
  },
  created() {
    let id = this.$route.query.id;
    this.id = id
    this.getAllDeatil()
  }
}
</script>
<style scoped>
.detailBox {
  background-color: #f7f7f7;
  padding-top: 25px;
}

.post-detail {
  width: 100%;
}

.m-auto {
  margin: 0 auto;
}

.w1200 {
  width: 1200px;
}

.post-detail {
  padding: 25px;
}

.post-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.post-views {
  margin-left: 20px;
}

.icon-views {
  margin-right: 10px;
}

.icon-views::before {
  margin-right: 10px;
  font-size: 12px;
}

.post-content {
  font-family: 微软雅黑;
  color: rgb(34, 34, 34);
}

.p25 {
  padding: 25px;
}

.arr-img {
  width: 8px;
  height: 10px;
  margin-right: 5px;
}

.no-wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.icon-nz::before {
  margin-right: 5px;
}

.cur-point:hover {
  cursor: pointer;
}

.ss-size {
  width: 144px;
  height: 40px;
  text-align: center;
  font-size: 18px;
}

.f-size {
  font-size: 18px;
}

.f-size-20 {
  font-size: 20px;
}

.f-size-16 {
  font-size: 16px;
}

.c-666 {
  color: #666;
}

.ss-news-l-item {
  border-radius: 10px;
}

.hot-list {
  background-color: #f7f7f7;
}

.post-detail {
  background-color: #fff;
}

.flexBox {
  background-color: #f7f7f7;
}
</style>
